import { LEGACY_THEME_TYPES } from '../../components/styled/theme/ThemeProvider';
import { types } from './user.types';

const initialState = {
    theme: LEGACY_THEME_TYPES.light,
    agencyId: '',
    selectedLocation: {
        agencyId: '',
        cityId: '',
    },
    personalInformation: {
        id: '',
        user_id: '',
        email: '',
        username: '',
        firstname: '',
        lastname: '',
        usertype: '',
        loading: false,
        error: '',
        role: {
            role: null,
            roleParse: {},
        },
        picture: '',
    },
    changePassword: {
        passwordChanged: false,
        loading: false,
        error: ''
    },
    updateUser: {
        userUpdated: false,
        loading: false,
        error: ''
    }
};

const user = (state = initialState, { type, payload }) => {
    switch (type) {


    case types.SET_USER_SELECTED_LOCATION_INFO:
        return {
            ...state,
            selectedLocation: {
                ...state.selectedLocation,
                ...payload,
            },
        };

    case types.SET_USER_PERSONAL_INFORMATION:
        return {
            ...state,
            personalInformation: {
                ...state.personalInformation,
                ...payload
            },
        };

    case types.SET_USER_PERSONAL_INFORMATION_REQUEST:
        return {
            ...state,
            updateUser: {
                ...state.updateUser,
                userUpdated: false,
                loading: true,
                error: 'checking'
            }
        };

    case types.SET_USER_PERSONAL_INFORMATION_SUCCESS:
        return {
            ...state,
            updateUser: {
                ...state.updateUser,
                loading: false,
                userUpdated: payload.data,
                error: ''
            }
        };

    case types.SET_USER_PERSONAL_INFORMATION_ERROR:
        return {
            ...state,
            updateUser: {
                ...state.updateUser,
                loading: false,
                error: payload,
                userUpdated: false
            }
        };

    case types.CHANGE_PASSWORD_REQUEST:
        return {
            ...state,
            changePassword: {
                ...state.changePassword,
                loading: true,
                passwordChanged: false,
                error: ''
            }
        };

    case types.CHANGE_PASSWORD_SUCCESS:
        return {
            ...state,
            changePassword: {
                ...state.changePassword,
                loading: false,
                passwordChanged: payload.data,
                error: ''
            }
        };

    case types.CHANGE_PASSWORD_ERROR:
        return {
            ...state,
            changePassword: {
                ...state.changePassword,
                loading: false,
                error: payload.message,
                passwordChanged: false
            }
        };

    case types.GET_USER_PERSONAL_INFORMATION_REQUEST:
        return {
            ...state,
            personalInformation: {
                ...state.personalInformation,
                loading: true,
            },
        };
    case types.GET_USER_PERSONAL_INFORMATION_SUCCESS:
        return {
            ...state,
            personalInformation: {
                ...state.personalInformation,
                loading: false,
                ...payload,
            },
        };

    case types.GET_USER_PERSONAL_INFORMATION_ERROR:
        return {
            ...state,
            personalInformation: {
                ...state.personalInformation,
                loading: false,
                error: payload,
            },
        };

    case types.SET_USER_AGENCY_ID:
        return {
            ...state,
            agencyId: payload,
        };

    case types.SET_USER_THEME:
        return {
            ...state,
            theme: payload,
        };

    case types.SET_USER_NAME:
        return {
            ...state,
            personalInformation: {
                ...state.personalInformation,
                username: payload,
            }
        };

    case types.CLEAR_USER_STORED_INFO:
        return initialState;

    default:
        return state;
    }
};

export default user;
